import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";
import { AgentThreadRecord } from "@/shared/domain/agentThread";
import { PaginatedResponse } from "@/shared/http";

export interface AdminAgentThreadsFilters {
  orgId?: string;
  createdBy?: string;
  sessionId?: string;
  hasErrors?: boolean;
  pageToken?: string;
  limit?: number;
}

export function useAdminAgentThreads(filters: AdminAgentThreadsFilters) {
  const { adminService } = useDomainServices();

  return useQuery<PaginatedResponse<AgentThreadRecord>, Error>({
    queryKey: [
      "adminAgentThreads",
      filters.orgId,
      filters.createdBy,
      filters.sessionId,
      filters.hasErrors,
      filters.pageToken,
      filters.limit,
    ],
    queryFn: ({ signal }) => {
      return adminService.getAdminAgentThreads({
        orgId: filters.orgId,
        createdBy: filters.createdBy,
        sessionId: filters.sessionId,
        hasErrors: filters.hasErrors,
        pageToken: filters.pageToken,
        limit: filters.limit,
        abortSignal: signal,
      });
    },
    staleTime: 30000,
  });
}
